import { userDoGetListEntities } from "services/user/list-entity";
import { useStore } from "stores/store";

export const fetchListEntities = async (listUuid: string) => {
  const listEntities = await userDoGetListEntities(listUuid);
  useStore.setState((state) => ({ ...state, listEntities }));
};
